import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function DesktopNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden md:flex items-center gap-8">
        {[1, 2, 3].map(i => <div key={i} className="h-4 w-20 bg-muted animate-pulse rounded-md" data-index={i === 1 ? 0 : undefined} />)}
      </div>;
  }
  return <nav className="hidden md:flex items-center gap-8">
      {menuItems.map((item, i) => <div key={item.id} className="relative group" data-index={i}>
          <Link to={item.href || "#"} className="text-[13px] font-medium text-foreground/70 hover:text-foreground transition-colors font-mono uppercase tracking-widest py-2 block">
            {item.label}
          </Link>
          <span className="absolute bottom-0 left-0 w-0 h-[1px] bg-foreground transition-all duration-300 group-hover:w-full" />
        </div>)}
    </nav>;
}
function HeaderContent() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-background/80 backdrop-blur-md border-b border-border/50 py-4" : "bg-transparent py-6"}`}>
      <div className="container px-6 flex items-center justify-between ![margin:0px_191.5px_0px_3px]">
        <Link to="/">
          <img src="https://moondosmedia.com/wp-content/uploads/2026/06/4-1.png" alt="Moondos Media" className="!w-[81px] !h-[81px] !p-0 ![margin:5px_0px_8px_48px]" />
        </Link>

        <MenuProvider menu_id="16" className="flex items-center gap-8">
          <DesktopNav />
        </MenuProvider>
      </div>
    </header>;
}
export default function Header() {
  return <section id="main-navigation" className="bg-background text-foreground">
      <HeaderContent />
    </section>;
}